import { IconButton } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import ViewModuleIcon from '@material-ui/icons/ViewModule';

export default function ScreenShareLayoutButton({
  classes,
  room,
  setShowLayoutPanel,
}) {
  const handleClick = (event) => {
    if (sessionStorage.getItem('layouts') == 'true') {
      sessionStorage.removeItem('layouts');
      setShowLayoutPanel(false);
    } else {
      sessionStorage.setItem('layouts', true);
      setShowLayoutPanel(true);
    }
  };

  return (
    <div>
      <Tooltip title='Change Layout'>
        <IconButton
          aria-label='more'
          aria-controls='long-menu'
          aria-haspopup='true'
          className={classes.toolbarButtons}
          onClick={handleClick}
        >
          <ViewModuleIcon />
        </IconButton>
      </Tooltip>
    </div>
  );
}
